import { pageInfo } from '../pageInfo/pageInfo.constant';

export const newProductConstant = {
  market: {
    key: 'newMarketProductInfo',
    category: 'PLUVA,PARTNER',
    path: pageInfo.productListPage.path,
  },
  openMarket: {
    key: 'newOpenMarketProductInfo',
    category: 'OPEN_MARKET',
    path: pageInfo.openMarketListPage.path,
  },
};
